var getCurrentScript = function() {
    var script = document.currentScript;
    if (!script) {
        /* Shim for IE11 and below */
        /* Do not take into account async scripts and inline scripts */

        var doc_scripts = document.getElementsByTagName('script');
        var scripts = [];

        for (var i = 0; i < doc_scripts.length; i++) {
            scripts.push(doc_scripts[i]);
        }

        scripts = scripts.filter(function(s) { return !s.async && !s.text && !s.textContent; });
        script = scripts.slice(-1)[0];
    }

    return script;
};

var isLocalScript = function(script) {
    return /\/_dash-component-suites\//.test(script.src);
};

Object.defineProperty(__webpack_require__, 'p', {
    get: (function () {
        var script = getCurrentScript();

        var url = script.src.split('/').slice(0, -1).join('/') + '/';

        return function() {
            return url;
        };
    })()
});

if (typeof jsonpScriptSrc !== 'undefined') {
    var __jsonpScriptSrc__ = jsonpScriptSrc;
    jsonpScriptSrc = function(chunkId) {
        var script = getCurrentScript();
        var isLocal = isLocalScript(script);

        var src = __jsonpScriptSrc__(chunkId);

        if(!isLocal) {
            return src;
        }

        var srcFragments = src.split('/');
        var fileFragments = srcFragments.slice(-1)[0].split('.');

        fileFragments.splice(1, 0, "v2_4_0m1652293188");
        srcFragments.splice(-1, 1, fileFragments.join('.'))

        return srcFragments.join('/');
    };
}
